import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center px-4">
            <h1 className="text-7xl font-extrabold text-gray-800">404</h1>
            <h2 className="text-3xl font-semibold text-gray-700 mt-2">Page Not Found</h2>
            <p className="text-gray-500 mt-2">
                Oops! The page you are looking for does not exist.
            </p>
            <Link
                to="/"
                className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
            >
                Go Back Home
            </Link>
        </div>
    );
};

export default NotFound;